var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: props.fill
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 7.125a1.125 1.125 0 11-2.25 0 1.125 1.125 0 012.25 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M17.246 16.206a7.545 7.545 0 01-4.554-.016l-.876.876a.8.8 0 01-.566.234H9.8v1.45a.8.8 0 01-.8.8H7.55V21a.8.8 0 01-.8.8H3a.8.8 0 01-.8-.8v-3.75a.8.8 0 01.235-.566L7.81 11.31a7.544 7.544 0 119.436 4.897zM11.72 4.045A5.944 5.944 0 1112.8 14.53a.8.8 0 00-.88.17l-1 1H9a.8.8 0 00-.8.8v1.45H6.75a.8.8 0 00-.8.8v1.45H3.8v-2.619l5.5-5.5a.8.8 0 00.17-.881 5.944 5.944 0 012.25-7.155z",
    fillRule: "evenodd"
  }))));
}

export default SvgKey;